import { render, staticRenderFns } from "./special-preferences.view.vue?vue&type=template&id=c1c2aa9e&"
import script from "./special-preferences.view.vue?vue&type=script&lang=ts&"
export * from "./special-preferences.view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports